import Sidebar from '../components/Sidebar';
import Reveal from '../components/Reveal';
import Announcements from '../middleware/announcements';
import { Button } from '@/components/ui/button';
import useCopyToClipboard from '../hooks/useCopyToClipboard';
import { copyServerIp } from '../lib/copyServerIp';
import { EXTERNAL, SERVER_IP } from '../config/links';
import '../styles/Hero.css';

const LandingPage = () => {
  const copy = useCopyToClipboard();

  return (
    <main className="content">
      <Sidebar />

      <section className="main-content">
        {/* The three things a visitor arrives wanting: the address, the
            Discord, and the store. No new copy — the prose below is
            unchanged. */}
        <header className="hero">
          <h1>ISN NETWORK</h1>
          <p className="hero__address">
            Play on <strong>{SERVER_IP}</strong>
          </p>
          <div className="hero__actions">
            <Button onClick={() => copyServerIp(copy)}>Copy server IP</Button>
            <Button variant="outline" asChild>
              <a href={EXTERNAL.discord} target="_blank" rel="noopener noreferrer">
                Join our Discord
              </a>
            </Button>
            <Button variant="secondary" asChild>
              <a href={EXTERNAL.store} target="_blank" rel="noopener noreferrer">
                Visit Store
              </a>
            </Button>
          </div>
        </header>

        <Reveal as="section">
          <h2>Welcome</h2>
          <p>
            Welcome to the official ISN Network Website!<br />
            This is the place for you to learn more about your factions experience.<br />
            Here you can find information about our server, our store, and our Discord.<br />
            Take a look around and see what we have to offer. We hope you enjoy your stay!
          </p>
        </Reveal>

        <Reveal as="section">
          <h2>About ISN Network</h2>
          <p>
            ISN Network is a factions server like no other. Offering a unique experience featuring monthly wipes,
            custom enchants, KOTHs, special items, and much more!<br />
            The server is designed to be fun and challenging, with a focus on player interaction and community building.<br />
            {/* One of the things that makes ISN Network so special is that our community come from a variety of different servers. 
            ISN was created by a group of friends who used to play factions themselves and wanted to create the best factions experience possible.  */}
            We hope that you'll take this opportunity to meet new friends or perhaps reconnect with old ones?
          </p>
          <button className="About-link" onClick={() => window.open('#/about')}>Learn More..</button>
        </Reveal>

        <Reveal as="section">
          <h2>Need Help?</h2>
          <p>
            Take a look at our <button className="Rules-link" onClick={() => window.open('#/rules')}>Rules</button> or <button className="FAQ-link" onClick={() => window.open('#/faq')}>FAQ</button> sections to see if your question has already been answered. If you still need help, please reach out to our staff team on Discord.<br />
            If you have any concerns or issues related to payments, please make a ticket on our Discord, and we will reply as soon as possible.
          </p>
        </Reveal>

       <Reveal as="div" className="Announcements">
          <Announcements />
        </Reveal>
      </section>
    </main>
  );
};

export default LandingPage;
